import cn from '@/utils/cn.util';

export const Loading = ({
  className,
  spin = true,
}: {
  className?: string;
  spin?: boolean;
}): React.JSX.Element => (
  <div
    className={cn(
      'flex items-center justify-center w-8 h-8 text-primary',
      className
    )}
  >
    <img
      src="../../../loader.svg"
      alt="Loading..."
      className={cn('h-auto w-auto', spin && 'animate-spin-slow')}
    />
  </div>
);
